const AboutUsMobileTopVector = ({
  width = 212,
  height = 451,
  fill = "#F8EDE3",
  className = ""
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 212 451"
      fill="none"
      className={className}
    >
      <path
        d="M57.6777 450.019L324.66 276.644C326.872 275.208 327.494 272.253 326.062 270.049L152.687 3.06608C151.227 0.817274 148.166 0.179466 145.944 1.66476C-1.3035 100.377 -43.4131 298.473 50.9502 448.544C52.3759 450.805 55.4315 451.467 57.6729 450.012L57.6777 450.019Z"
        fill={fill}
      />
    </svg>
  );
};

export default AboutUsMobileTopVector;
